export const PROJECTS = [
  {
    id: 1,
    slug: "roggaecher-nord",
    category: "Wohnbau",
    title: "Überbauung Roggächer «Nord»",
    location: "Mühlau AG",
    service: "Bauendreinigung Gebäude B & C",
    since: "in Arbeit",
    img: "/references/roggaecher/roggaecher-a.webp",
    gallery: [
      "/references/roggaecher/roggaecher-a.webp",
      "/references/roggaecher/roggaecher-i.webp",
      "/references/roggaecher/roggaecher-f.jpg",
      "/references/roggaecher/roggaecher-b.webp",
      "/references/roggaecher/roggaecher-c.webp",
      "/references/roggaecher/roggaecher-h.jpg",
      "/references/roggaecher/roggaecher-g.jpg",
    ],
    details: [
      "Bauendreinigung für Gebäude B und Gebäude C",
      "Baugrob- und Baufeinreinigung aller Wohnungen",
      "Küchen, Nasszellen und Fenster in Bestform",
      "Projekt aktuell in Arbeit — weitere Bilder folgen",
    ],
  },
];
